<template>
  <div>
    <el-row>
      <el-col :span="20">
        <el-form size="small" :model="searchForm" ref="searchForm" :inline="true" style="margin-top:20px">
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.name"></el-input>
          </el-form-item>
          <el-form-item label="产品编码：">
            <el-input size="medium" v-model="searchForm.code"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="querySearch">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border :data="tableData" style="margin-top:20px">
          <el-table-column label="序号" type="index" width="50px"></el-table-column>
          <el-table-column label="产品名称" prop="NAME"></el-table-column>
          <el-table-column label="编码" prop="PRODUCT_CODE"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
          <el-table-column label="单价" prop="PRICE">
            <template slot-scope="scope">
              <el-input v-model="scope.row.PRICE" @change="changePrice" :placeholder="scope.row.PRICE"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="开始日期" prop="START_DAY">
            <template slot-scope="scope">
              <el-date-picker v-model="scope.row.START_DAY" align="right" type="date" placeholder="选择日期"
                value-format="yyyy-MM-dd" style="width:100%">
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column label="结束日期" prop="END_DAY">
            <template slot-scope="scope">
              <el-date-picker v-model="scope.row.END_DAY" align="right" type="date" placeholder="选择日期"
                value-format="yyyy-MM-dd" style="width:100%">
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="downData(scope.row)">上架</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      searchForm: {},
      tableData: [],
      project_name: sessionStorage.getItem('projectName'),
      customer_name: sessionStorage.getItem('CUSTOMER_NAME'),
    };
  },
  created() {
    this.queryTable();
  },
  methods: {
    // 监控单价修改
    changePrice(e) {
      const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (!reg.test(e) || e == 0) {
        this.$message.show({ text: '请输入大于零的价格', type: 'warning' });
      }
    },
    // ---------------上架
    downData(row) {
      this.$confirm('确定上架吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          SERVICE_ID: '10041',
          OTYPE: 23,
          USER_ID: sessionStorage.getItem('userId'),
          SESSION: sessionStorage.getItem('session'),
          SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
          PROJECT_ID: Number(sessionStorage.getItem('projectId')),
          PRODUCT_CODE: row.PRODUCT_CODE,

        };
        if (row.PRICE) {
          if (validation.价格正数验证(row.PRICE)) {
            params.PRICE = Number(row.PRICE);
          } else {
            this.$message.show({ text: '请输入大于零的价格', type: 'warning' });
            return false;
          }
        } else {
          this.$message.show({ text: '请输入价格', type: 'warning' });
          return false;
        }
        if (row.START_DAY) {
          params.START_DAY = row.START_DAY;
        } else {
          this.$message.show({ text: '请选择开始日期', type: 'warning' });
          return false;
        }
        if (row.END_DAY) {
          params.END_DAY = row.END_DAY;
        } else {
          this.$message.show({ text: '请选择开始日期', type: 'warning' });
          return false;
        }
        http.post(params)
          .then((result) => {
            this.$message.show({ text: '上架成功', type: 'success' });
            this.queryTable();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
      }).catch(() => {
        this.$message.show({ text: '操作取消', type: 'info' });
      });
    },
    queryTable() {
      const params = {
        SERVICE_ID: '10041',
        OTYPE: 22,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PROJECT_ID: Number(sessionStorage.getItem('projectId')),
        PRODUCT_NAME: this.searchForm.name,
      };
      if (this.searchForm.code) {
        params.PRODUCT_CODE = Number(this.searchForm.code);
      }
      http.post(params)
        .then((result) => {
          if (result.length !== 0) {
            this.tableData = result[0].LIST.map((item) => Object.assign(item, { PRICE: '' }));
          } else {
            this.$message.show({ text: '暂无数据', type: 'success' });
            this.tableData = [];
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    querySearch() {
      this.queryTable();
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/customerManage/addProjectProduct.vue